// extracted by mini-css-extract-plugin
export default {"grid":"Features_grid__CViBE","card":"Features_card__yW+k3"};